import {
  AlignmentIssueDropdownValues,
  AlignmentStatusDropdownValues,
} from '../../constants/alignment';
import {
  getAlignmentIssueLabel,
  getAlignmentStatusLabel,
  generateDropdownOptionsFromEvents,
} from '../../utils/alignment-data';

export const generateCompetitionOptions = (events) => {
  const competitionsMap = new Map();

  events?.forEach((event) => {
    const competition = event?.videoInfo?.competition;
    const countryName = event?.videoInfo?.countryName;

    if (competition && !competitionsMap.has(competition)) {
      competitionsMap.set(competition, {
        label: countryName ? `${countryName} ${competition}` : competition,
        // We need to keep the original competition name for filtering purposes as it doesn't include the country name
        value: competition,
      });
    }
  });

  return Array.from(competitionsMap.values());
};

export const generateSeasonOptions = (events) =>
  generateDropdownOptionsFromEvents(
    events,
    (item) => item?.videoInfo?.seasonName,
  );

export const generateAlignmentIssueOptions = (intl) => [
  {
    label: intl.formatMessage({
      defaultMessage: 'All',
      id: 'b1c94',
    }),
    value: AlignmentIssueDropdownValues.ALL,
  },
  {
    label: getAlignmentIssueLabel(
      AlignmentIssueDropdownValues.LICENSED_VIDEO,
      intl,
    ),
    value: AlignmentIssueDropdownValues.LICENSED_VIDEO,
  },
  {
    label: getAlignmentIssueLabel(
      AlignmentIssueDropdownValues.UNLICENSED_VIDEO,
      intl,
    ),
    value: AlignmentIssueDropdownValues.UNLICENSED_VIDEO,
  },
];

export const generateAlignmentStatusOptions = (intl) => [
  {
    label: intl.formatMessage({
      defaultMessage: 'All',
      id: 'b1c94',
    }),
    value: AlignmentStatusDropdownValues.ALL,
  },
  {
    label: getAlignmentStatusLabel(
      AlignmentStatusDropdownValues.REQUIRES_NEW_HUDL_VIDEO,
      intl,
    ),
    value: AlignmentStatusDropdownValues.REQUIRES_NEW_HUDL_VIDEO,
  },
  {
    label: getAlignmentStatusLabel(
      AlignmentStatusDropdownValues.REQUIRES_RECOLLECTION,
      intl,
    ),
    value: AlignmentStatusDropdownValues.REQUIRES_RECOLLECTION,
  },
  {
    label: getAlignmentStatusLabel(undefined, intl),
    value: AlignmentStatusDropdownValues.AWAITING_REVIEW,
  },
];
